import {Box, Grid, Skeleton, Typography} from '@mui/material';
import {useEffect, useState} from 'react';
import {useMutation, useQueryClient} from 'react-query';
import {useDispatch} from 'react-redux';
import CustomisedButton from '../../../../components/button/button';
import FAQ from '../../../../components/card/FaqCard/faq';
import SplitedWithButtonCard from '../../../../components/card/SplitedWithButtonCard/SplitedWithButtonCard';
import EmptyStyle from '../../../../components/emptyStyles/emptyStyle';
import EmptyLoanStyle from '../../../../components/icons/EmptyLoanStyle';
import ElementTitle from '../../../../components/title/elementTitle/elementTitle';
import {TGetTradeFaqsResponse} from '../../../../models/trade.model';
import {
    changeRouteType,
    getNextState,
    getpervInnerState,
} from '../../../../redux/handleBackBtn/handleBackBtnSlice';
import {setHeaderTitle} from '../../../../redux/headerTitle/headerTitleSlice';
import {getpervStateTab} from '../../../../redux/loansTab/loansTabSlice';
import {GetTradeFaqs} from '../../../../services/trade.service';
import {ITradeProps} from './ITrade';
import {SmartImage} from '../../../../components/images/SmartImage';
import {useNavigate} from 'react-router-dom';

export default function TradeProfile({
    setState,
    totalCreditForAsset,
    promotionItems,
    setMortgageType,
    setTabChild,
    GetTotalCreditForAssetConvertLoading,
}: ITradeProps) {
    const navigate = useNavigate();
    const [tradeFaqs, setTradeFaqs] = useState<TGetTradeFaqsResponse>([]);
    const [openIndex, setOpenIndex] = useState<number>(0);
    const queryClient = useQueryClient();
    const dispatch = useDispatch();
    const randomKeyForDispatch = Math.random();
    const {mutate: GetTradeFaqsMutate, isLoading} = useMutation(GetTradeFaqs, {
        onSuccess: (data: TGetTradeFaqsResponse) => {
            if (data) {
                setTradeFaqs(data);
            }
        },
        onError: () => {},
    });

    useEffect(() => {
        dispatch(
            setHeaderTitle({
                color: 'var(--header-color)',
                header: 'تبدیل دارایی',
                parentRoute: 'trade',
            })
        );
        dispatch(changeRouteType({routeType: 'child'}));
        dispatch(
            getpervInnerState({prevInnerState: `home ${randomKeyForDispatch}`})
        );
        GetTradeFaqsMutate();
    }, []);
    const handleEmpty = () => {
        navigate('/loans/request');
    };
    const handleGetLoan = (loanTemplateKey: string) => {
        navigate('/loans/request/createNewRequest');
        queryClient.setQueryData('LOAN_TEMPLATE_KEY', loanTemplateKey);
        // dispatch(getpervStateTab({ prevState: 'registerLoan' }))
    };
    if (GetTotalCreditForAssetConvertLoading) {
        return (
            <Box sx={{paddingInline: '20px'}}>
                {[...Array(4)].map((_, index) => (
                    <Skeleton
                        key={index}
                        sx={{
                            marginBottom: '20px',
                            borderRadius: '10px',
                            backgroundColor: 'lightgray',
                        }}
                        variant="rectangular"
                        height={100}
                        width={'100%'}
                    />
                ))}
            </Box>
        );
    }
    if (isLoading) {
        return (
            <Box sx={{paddingInline: '20px'}}>
                {[...Array(4)].map((_, index) => (
                    <Skeleton
                        key={index}
                        sx={{
                            marginBottom: '20px',
                            borderRadius: '10px',
                            backgroundColor: 'lightgray',
                        }}
                        variant="rectangular"
                        height={100}
                        width={'100%'}
                    />
                ))}
            </Box>
        );
    }

    if (totalCreditForAsset?.length === 0 && promotionItems?.length === 0) {
        return (
            <EmptyStyle
                text="در حال حاضر دارایی قابل تبدیل ندارید."
                emphasisedWords={['دارایی']}
                emphasisedWordsColor="#BBA57A"
                icon={
                    <EmptyLoanStyle className="text-[var(--primary-text-color)]" />
                }
            >
                <div className="w-full py-5 pb-8 sm:pt-4">
                    <CustomisedButton
                        title="ثبت درخواست تسهیلات"
                        disable={false}
                        onClick={handleEmpty}
                        type="button"
                    />
                </div>
            </EmptyStyle>
        );
    }
    return (
        <div className="h-[calc(100svh-60px)] px-5 pt-4 pb-[60px] overflow-y-auto">
            <Box>
                {totalCreditForAsset?.map((item, index) => (
                    <Grid
                        container
                        className="py-5"
                        style={{paddingTop: '0px'}}
                        key={index}
                    >
                        <Grid
                            item
                            xs={12}
                            className="py-5"
                            style={{paddingTop: '0px'}}
                        >
                            <SplitedWithButtonCard
                                title={item.title}
                                firstRowDescription={`${item.totalAmountInRials.toLocaleString('fa')} ریال`}
                                secondRowDescription={item.description}
                                buttonTitle={item.exchangeCommandTitle}
                                onClick={() => {
                                    setMortgageType!(item.mortgageType);
                                    setState('trade');
                                }}
                            />
                        </Grid>
                    </Grid>
                ))}
                {promotionItems?.map((item, index) => (
                    <Box className="flex flex-col gap-4 py-5" key={index}>
                        {item?.imageUrl && (
                            <div
                                className="cursor-pointer"
                                onClick={() =>
                                    handleGetLoan(item.loanTemplateKey)
                                }
                            >
                                <SmartImage
                                    src={item?.imageUrl}
                                    alt="image"
                                    imageStyle={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'cover',
                                        display: 'block',
                                        borderRadius: '8px',
                                    }}
                                    size={'100%'}
                                    borderRadius={8}
                                />
                            </div>
                        )}
                        <Typography
                            className="text-center"
                            sx={{
                                fontSize: ' 0.875rem !important',
                                color: 'var(--primary-text-color)',
                            }}
                        >
                            {item.promotion}
                        </Typography>
                        {item.loanTemplateKey &&
                            item.promotion &&
                            item?.command && (
                                <Box className="w-1/2 mx-auto">
                                    <CustomisedButton
                                        disable={false}
                                        title={item.command}
                                        onClick={() =>
                                            handleGetLoan(item.loanTemplateKey)
                                        }
                                        type="button"
                                    />
                                </Box>
                            )}
                    </Box>
                ))}
                {tradeFaqs?.length > 0 && (
                    <ElementTitle title="سوالات متداول" />
                )}
                {tradeFaqs?.map((item, index) => (
                    <div className="my-4">
                        <FAQ
                            onToggle={() =>
                                setOpenIndex(openIndex === index ? -1 : index)
                            }
                            open={openIndex === index}
                            answer={item.answer}
                            question={item.question}
                            key={index}
                        />
                    </div>
                ))}
            </Box>
        </div>
    );
}
